import i18next from 'i18next';
import * as en from '../translations/en.json';
import * as fr from '../translations/fr.json';

i18next.init({
    fallbackLng: 'fr',
    debug: false,
    keySeparator: '.',
    resources: {
        fr: { translation: fr },
        en: { translation: en },
    },
});

export const i18n = i18next;
export const { t } = i18next;

/**
 * Usage:
 *
 * import { i18n } from 'path-to/i18n';
 *
 * ...
 *
 * <Text>{i18n . t('hello', { lng: lang })}</Text>
 *
 * ...
 *
 */

/**
 * keys to be kept
 * i18n.t('mission.details.hours')
 * i18n.t('mission.details.minute')
 * i18n.t('mission.details.minutes')
 */
